var Positions;
(function (Positions) {
    Positions["leftTop"] = "left top";
    Positions["leftBottom"] = "left bottom";
    Positions["leftCenter"] = "left center";
    Positions["topLeft"] = "top left";
    Positions["topCenter"] = "top center";
    Positions["topRight"] = "top right";
    Positions["rightTop"] = "right top";
    Positions["rightCenter"] = "right center";
    Positions["rightBottom"] = "right bottom";
    Positions["bottomLeft"] = "bottom left";
    Positions["bottomCenter"] = "bottom center";
    Positions["bottomRight"] = "bottom right";
    Positions["centerTop"] = "center top";
    Positions["centerBottom"] = "center bottom";
    Positions["center"] = "center center";
    /*
     * Only used to small mobile screens when none of the above fit
     */
    Positions["topMiddle"] = "top middle";
    Positions["bottomMiddle"] = "bottom middle";
})(Positions || (Positions = {}));
export default Positions;
